import {
  Router,
  LocationProvider,
  createMemorySource,
  createHistory,
} from "@gatsbyjs/reach-router";
import clsx from "clsx";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

import { useUserContext } from "../hooks";

import * as defaultStyles from "./LoginDialog.module.css";
import LoginDialogRouter from "./LoginDialogRouter";
import LoginDialogStart from "./LoginDialogStart";

LoginDialog.propTypes = {
  styles: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
};

export default function LoginDialog({
  styles = defaultStyles,
  className,
  ...restProps
}) {
  const { pending } = useUserContext();
  let routerHistory = useMemo(() => {
    let source = createMemorySource("/");
    let history = createHistory(source);
    return history;
  }, []);
  if (pending) {
    return null;
  }
  if (!routerHistory) {
    return null;
  }
  return (
    <LocationProvider history={routerHistory}>
      <div className={clsx(styles.component, className)} {...restProps}>
        <div className={clsx(styles.wrapper)}>
          <Router className={clsx(styles.box)}>
            <LoginDialogStart path="/" />
            <LoginDialogRouter path="login/*" />
          </Router>
          {/* <nav className={clsx(styles.nav)}>
            <ul className={clsx(styles.list)}>
              <li className={clsx(styles.item)}>
                <a href="/">Problem att logga in?</a>
              </li>
              <li className={clsx(styles.item)}>
                <a href="/">Feedback</a>
              </li>
            </ul>
          </nav> */}
        </div>
      </div>
    </LocationProvider>
  );
}
